// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_YYM","cls2":"ImpactHubModal-cls2_nwA ImpactHubModal-cls1_YYM"};